import { createReducer, success } from 'redux/shelf';
import { search } from 'redux/shelf/api';

const scoreFormat = (score) => Math.round(score * 100) / 100;

const enrichItems = (items) => {
  return items.map((item) => ({
    ...item,
    price: item.price?.length > 0 ? item.price[0] : item.price,
    discounted: !!item.compare_at,
    ...(item.score
      ? {
          score: {
            popularity_formatted: Math.round(item.score.popularityBoost),
            ...item.score,
          },
        }
      : {}),
  }));
};

export const actions = {
  fetchSearch: search.post`search`(),
  fetchCollection: search.post`smart-collection/:slot`(),
  fetchMoreSearch: search.post`search`(),
  fetchMoreCollection: search.post`smart-collection/:slot`(),
  fetchColorFacets: search.post`facet/values`(),
};

export const reducer = createReducer(actions, {
  [success(actions.fetchSearch)]: (state, { payload: { items, meta } }) => ({
    ...state,
    items: enrichItems(items),
    meta,
  }),
  [success(actions.fetchCollection)]: (
    state,
    { payload: { items, meta } }
  ) => ({
    ...state,
    items: enrichItems(items),
    meta,
  }),
  [success(actions.fetchMoreSearch)]: (
    state,
    { payload: { items, meta } }
  ) => ({
    ...state,
    items: [...state.items, ...enrichItems(items)],
    meta,
  }),
  [success(actions.fetchMoreCollection)]: (
    state,
    { payload: { items, meta } }
  ) => ({
    ...state,
    items: [...state.items, ...enrichItems(items)],
    meta,
  }),
  [success(actions.fetchColorFacets)]: (state, { payload }) => {
    return {
      ...state,
      colors: payload.facets[0].values.map(({ value }) => value),
    };
  },
});
